import env from '../../utils/env';
import request from './request';

export function createCategory(formData: FormData) {
  const requestUrl = `${env.aceApi}api/1/categories`;
  const data = JSON.stringify(formData);
  return request(requestUrl, 'POST', { 'Content-Type': 'application/json' }, data);
}
export const getAllCategories = () => request(`${env.aceApi}api/1/categories/all`);

export const getCategoriesByCampaignId = (campaignId: string) =>
  request(`${env.aceApi}api/1/categories/campaigns/${campaignId}`);

export const updateCategories = (campaignId: string, categories: Record<string, string>) => {
  const requestUrl = `${env.aceApi}api/1/categories/campaigns/${campaignId}`;
  const data = JSON.stringify(categories);
  return request(requestUrl, 'PUT', { 'Content-Type': 'application/json' }, data);
};
